import { render, staticRenderFns } from "./XQuickActionButton.vue?vue&type=template&id=53053e70"
import script from "./XQuickActionButton.vue?vue&type=script&lang=js"
export * from "./XQuickActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports